import { useBaseStore } from '../../base';

export const useEntryPointFlow = () => {
	const { appSettings } = useBaseStore();

	return appSettings.entryPointFlow;
};
